import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(collection: Array<any>, attribute: string = '', containedIn?: string): Array<any> {
    if (containedIn == null) {
      return collection;
    } else {
      return collection
        .filter(item => containedIn.split(';').filter(v => v)
          .some(label => label === item[attribute])
        );
    }
  }

}
